// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mGkqB","col":"styles_col__3xG7u"};